var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CockpitLeft"}},[_c('div',{staticClass:"left-middle"},[_c('cockpit-title',{attrs:{"title":"诉求量分析","enTitle":"sqlfx"}}),_c('div',{staticClass:"echartsBox"},[_c('demand')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }